import React, { useState, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faHandHoldingUsd, faExclamationTriangle, faCashRegister } from '@fortawesome/free-solid-svg-icons';
import { formatCurrency } from '../../../../utils/numberFormatter';
import PaymentMethods from '../../../PaymentFlow/PaymentMethods';
import { SelectedOfferContext } from '../../../../context/SelectedOfferContext';

const PaymentModal = ({ 
  show, 
  onClose, 
  onConfirm, 
  isProcessing = false 
}) => {
  const { selectedOffer } = useContext(SelectedOfferContext);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [transferReceipt, setTransferReceipt] = useState(null);

  const handleConfirmPayment = () => {
    if (!paymentMethod) return;
    const paymentData = {
      requiresAdvance: true,
      payment_method: paymentMethod,
      amount: selectedOffer?.monthlyPayment || 0,
      voucher: transferReceipt
    };
    onConfirm(paymentData);
  };

  const handleFileChange = (e) => {
    setTransferReceipt(e.target.files[0]);
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Pago Inicial Requerido</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Resumen del Pago */}
        <div className="mb-0">
          <div className="card shadow-sm border-0 text-center mb-2">
            <div className="card-header bg-white border-0 pb-0">
              <FontAwesomeIcon icon={faHandHoldingUsd} className="me-2" />
              <strong>Importe a pagar</strong>
            </div>
            <div className="card-body pt-2 text-center">
              <span
                style={{
                  fontSize: '2.5rem',
                  color: '#1976d2', // Azul Material UI
                  fontWeight: 700,
                  letterSpacing: '1px',
                  display: 'block',
                }}
              >
                {formatCurrency(selectedOffer?.downpaymentAmount || 0, 2)}
              </span>
            </div>
          </div>
        </div>

        {/* Selección de medio de pago y comprobante */}
        <div className="mb-0">
          <div className="card shadow-sm border-0 text-center mb-3">
            <div className="card-header bg-white border-0 pb-0">
              <FontAwesomeIcon icon={faCreditCard} className="me-2" />
              <strong>Seleccionar Medio de Pago</strong>
            </div>
            <div className="card-body pt-0">
              <div className="mb-3">
                <PaymentMethods
                  selectedMethod={paymentMethod}
                  onMethodSelect={(method) => {
                    setPaymentMethod(method);
                    setTransferReceipt(null);
                  }}
                />
                {paymentMethod && (
                  <div className="text-center mt-2 mb-2">
                    <span className="" style={{ fontSize: '1rem', padding: '0.5em 1.2em' }}>
                      {paymentMethod === 'cash' && 'Efectivo'}
                      {paymentMethod === 'bank_transfer' && 'Transferencia'}
                    </span>
                  </div>
                )}
              </div>
              {paymentMethod === 'bank_transfer' && (
                <div className="mt-3">
                  <label className="form-label fw-semibold" htmlFor="transferReceipt">
                    Comprobante de transferencia
                  </label>
                  <div
                    className={`transfer-receipt-dropzone ${transferReceipt ? 'uploaded' : ''}`}
                    onClick={() => document.getElementById('transferReceipt').click()}
                    style={{ 
                      userSelect: 'none',
                      border: '2px dashed #dee2e6',
                      borderRadius: '8px',
                      padding: '20px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      backgroundColor: transferReceipt ? '#f8f9fa' : 'white',
                      width: '100%'
                    }}
                  >
                    <span className="transfer-receipt-icon">
                      <i className="bi bi-file-earmark-text fs-4"></i>
                    </span>
                    <div className="transfer-receipt-name flex-grow-1 mt-2">
                      {transferReceipt ? transferReceipt.name : 'Arrastra el archivo aquí o haz clic para seleccionarlo'}
                    </div>
                    <span className="transfer-receipt-status mt-2">
                      {transferReceipt ? (
                        <i className="bi bi-check-circle-fill text-success"></i>
                      ) : (
                        <i className="bi bi-clock"></i>
                      )}
                    </span>
                    <input
                      type="file"
                      id="transferReceipt"
                      accept="image/*,application/pdf"
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
              )}

              {/* Nuevo bloque de información de anticipo */}
              {selectedOffer?.isDownpaymentPlan && (
                <div className="mt-3 text-start p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                  <div className="d-flex align-items-start">
                    <div>
                      <p className="mb-0" style={{ fontSize: '0.95rem' }}>
                      Para confirmar la creación de este préstamo, el cliente deberá abonar un anticipo equivalente {' '}
                      {selectedOffer.downpaymentType === 'percentage' ? (
                          <span className="text-primary">al {selectedOffer.downpaymentValue}% del capital</span>
                        ) : (
                          <span className="text-primary">a {selectedOffer.downpaymentValue} cuota{selectedOffer.downpaymentValue > 1 ? 's' : ''}</span>
                        )} en este momento.
                      </p>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
       <div className="d-flex justify-content-between w-100">
        <Button variant="secondary" onClick={onClose} disabled={isProcessing}>
          Cancelar
        </Button>
        <Button 
          variant="primary" 
          onClick={handleConfirmPayment}
          disabled={isProcessing || !paymentMethod}
        >
          {isProcessing ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Procesando...
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faHandHoldingUsd} className="me-2" />
              Generar Préstamo y Registrar Pago
            </>
          )}
        </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentModal;